import moment from "moment-timezone";

export const utcTimeLocal = (date: string, template?: string): string => {
  const zoneName = moment.tz.guess();
  const currentTime = moment.utc(date).tz(zoneName);

  return currentTime.format(template);
};
